import { api, ApiResponse } from './api';

export interface ProfileData {
  id: string;
  uuid: string;
  name: string;
  email: string;
  avatar_url?: string;
  timezone?: string;
  oauth_provider?: string | null;
}

export interface UpdateProfileData {
  name?: string;
  email?: string;
  timezone?: string;
}

export interface ChangePasswordData {
  current_password: string;
  new_password: string;
}

export const profileApi = {
  getProfile: async (): Promise<ProfileData> => {
    const response = await api.get<ApiResponse<ProfileData>>('/api/v1/auth/me');
    return response.data.data!;
  },

  updateProfile: async (data: UpdateProfileData): Promise<ProfileData> => {
    const response = await api.patch<ApiResponse<ProfileData>>('/api/v1/auth/profile', data);
    return response.data.data!;
  },

  changePassword: async (data: ChangePasswordData): Promise<{ message: string }> => {
    const response = await api.post<ApiResponse<{ message: string }>>('/api/v1/auth/change-password', data);
    return response.data.data!;
  },
};
